class CollectionGridManager {
  constructor() {
    // Collection heading elements
    this.catSwitcherMenu = document.querySelector(".CAT-header__nav-list");
    this.catSwitcherMenuTabs = this.catSwitcherMenu?.querySelectorAll(".CAT-header__nav-link");
    this.customTabs = this.catSwitcherMenu?.closest('.custom-tabs');
    
    // Infinite scroll properties
    this.pageNr = 1;
    this.CAT_collection_grid_template_id = document.querySelector('#product-grid')?.dataset.id;
    this.isFetching = false;
    this.UTMproductsRearenged = false;
    
    this.init();
  }

  init() {
    this.triggerSearchPopup();
    this.initInfiniteScroll();
    this.setupInitialFilters();
    this.setupReviewHandlers();
    this.handleStickyFilterButton();
    this.collectionSwitcherMenuHandler();

    // Hide orphan promos (rows with no products). Run multiple times because the
    // grid height settles only after images load (and `load` may already have fired
    // by the time this deferred script runs).
    const runPrune = () => this.pruneOrphanPromos();
    requestAnimationFrame(runPrune);
    if (document.readyState === 'complete') {
      runPrune();
    } else {
      window.addEventListener('load', runPrune);
    }
    setTimeout(runPrune, 600);
    setTimeout(runPrune, 1500);
    // re-run as grid images finish loading (they change product heights/positions)
    const promoGrid = document.querySelector('#product-grid');
    if (promoGrid) {
      promoGrid.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', () => this.schedulePrune(), { once: true });
      });
    }
    window.addEventListener('resize', () => this.schedulePrune(150));
  }

  // Coalesce prune runs: each one forces a full layout, and image `load` events arrive
  // one by one, so running it per image kept the main thread busy (hurts INP).
  schedulePrune(delay = 100) {
    clearTimeout(this._pruneTimer);
    this._pruneTimer = setTimeout(() => this.pruneOrphanPromos(), delay);
  }

  // Hide "trailing" promos — the ones positioned BELOW the last product (floating alone)
  pruneOrphanPromos() {
    const grid = document.querySelector('#product-grid');
    if (!grid) return;
    const children = Array.from(grid.children);
    const promos = children.filter(el => el.classList.contains('promo-card'));
    if (!promos.length) return;

    // reset (show all again so measurements are correct)
    promos.forEach(p => p.classList.remove('promo-card--orphan'));

    const products = children.filter(
      el => !el.classList.contains('promo-card') && el.offsetParent !== null
    );
    if (!products.length) {
      promos.forEach(p => p.classList.add('promo-card--orphan'));
      return;
    }

    const tol = 20; // px tolerance
    // bottom edge of the lowest product
    let lastProductBottom = 0;
    products.forEach(prod => {
      const b = prod.offsetTop + prod.offsetHeight;
      if (b > lastProductBottom) lastProductBottom = b;
    });

    // a promo is orphan only if it starts below the last product (no products beside/below it)
    promos.forEach(p => {
      if (p.offsetParent === null) return;
      if (p.offsetTop >= lastProductBottom - tol) {
        p.classList.add('promo-card--orphan');
      }
    });
  }

  // Search functionality
  triggerSearchPopup() {
    // Delegated once on document so it survives grid/toolbar swaps when
    // switching collection tabs (innerHTML is replaced, killing direct listeners).
    if (this._searchDelegated) return;
    this._searchDelegated = true;

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.CAT-header__search-action .search-button')) return;

      const headerSearchPopup = document.querySelector('.header__search details');
      if (headerSearchPopup) {
        headerSearchPopup.open = true;
        const searchInput = headerSearchPopup.querySelector('input[type="search"]');
        if (searchInput) {
          searchInput.focus();
        }
      }
    });
  }

  // Collection switcher menu handler
  collectionSwitcherMenuHandler() {
    if (!this.catSwitcherMenuTabs) return;

    this.catSwitcherMenuTabs.forEach((catSwitcherMenuTab, index) => {
      catSwitcherMenuTab.addEventListener('click', (event) => {
        const target = event.currentTarget;

        this.catSwitcherMenuTabs.forEach(tab => tab.classList.remove('active'));
        target.classList.add('active');

        // SEO - Update Collection Title
        document.title = target.dataset.collectionTitle;

        let handle = target.dataset.handle;
        if (window.location.pathname.split('/').includes(handle)) return;

        const productGridId = document.querySelector('.product-grid-wrapper').id;
        this.fetchCollectionCategorie(productGridId, handle);

        // Hide low reviews widgets after content is loaded
        setTimeout(hideLowReviewWidgets, 1000);
      });
    });
  }

  // Fetch collection categories (from CollectionHeadingManager)
  fetchCollectionCategorie(sectionId, colectionHandle) {
    let fetchUrl;
    let url;

    //fetch for products collections change
    let query_params = window.location.search.replace("?","");

    //format query params
    if(query_params == ''){
      query_params = query_params.slice(0, query_params.indexOf('section_id=')) + query_params.slice(query_params.indexOf('&', query_params.indexOf('section_id=')) + 1);
    }
    let path = window.location.href.slice(0, window.location.href.lastIndexOf('/'));
    let new_path = window.location.pathname;
    
    if (new_path.split('/').length == 4 && !colectionHandle.includes('set')) {
      let updated_path = new_path.split('/');
      updated_path[updated_path.length - 2] = colectionHandle;
      updated_path = updated_path.join('/');
      path = `${updated_path}`;

      fetchUrl = `${path}?section_id=${sectionId}&${query_params}`;
      url = `${path}${query_params != '' ? '?': ''}${query_params}`;
    } else {
      if (colectionHandle.includes('set')) {
        fetchUrl = `${window.location.origin}/collections/${colectionHandle}?section_id=${sectionId}`;
        url = `${window.location.origin}/collections/${colectionHandle}`;
        
        extraFiltersSettings.closeFilter();
      } else {
        fetchUrl = `${path}/${colectionHandle}?section_id=${sectionId}&${query_params}`;
        url = `${path}/${colectionHandle}${query_params != '' ? '?': ''}${query_params}`;
      }
    }

    // Update url
    window.history.pushState("", "", url);

    // Add loading to container
    document.querySelector('.collection').classList.add('loading');

    fetch(fetchUrl)
    .then(response => response.text())
    .then((response) => {
      const section_id = `#${sectionId}`;
      this.renderNewItems(section_id, response);

      // special case for vanilla expression collection: re-inject GSAP + init scripts
      if (colectionHandle == 'vanilla-expressions') {
        const doc = new DOMParser().parseFromString(response, 'text/html');
        doc.querySelectorAll('[data-script-to-reload]').forEach(oldScript => {
          const runnableScript = document.createElement('script');
          if (oldScript.hasAttribute('src')) {
            runnableScript.src = oldScript.getAttribute('src');
            document.body.appendChild(runnableScript);
          } else {
            runnableScript.textContent = oldScript.textContent;
            document.body.appendChild(runnableScript);
            runnableScript.remove();
          }
        });

        if (typeof window.initDossierSpecialCarousel === 'function' && typeof window.initDossierParallaxSection === 'function') {
          window.initDossierSpecialCarousel();
          window.initDossierParallaxSection();
        } else {
          setTimeout(() => {
            window.location.href = `${Shopify.routes.root}collections/vanilla-expressions`;
          }, 500);
        }
      }

      // Remove loading
      document.querySelector('.collection').classList.remove('loading');
    })
    .catch((error) => {
      console.error('Error fetching data:', error);
    });
  }

  // Render new items (from CollectionHeadingManager)
  renderNewItems(section, html) {
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');

    const newEmptyResults = parsedHtml.querySelector('.no-results');

    const newSection = parsedHtml.querySelector(section);
    const currentSection = document.querySelector(section);

    if (newSection && currentSection) {
      currentSection.innerHTML = newSection.innerHTML;

      const newProductGrid = parsedHtml.querySelector('#product-grid');
      const currentProductGrid = document.querySelector('#product-grid');

      if(!newProductGrid || !currentProductGrid) return;
      currentProductGrid.classList.add('pageOne');
      currentProductGrid.dataset.pages = newProductGrid.dataset.pages;

      // Add Filters Functionality
      extraFiltersSettings.init();

      if (newEmptyResults) return;

      // Update product reviews widgets
      if (typeof yotpoWidgetsContainer !== 'undefined' && typeof yotpoWidgetsContainer.initWidgets === 'function') {
        yotpoWidgetsContainer.initWidgets();
      }
        
      setTimeout(()=>{
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        if (typeof initializeScrollZoomAnimationTrigger === 'function') initializeScrollZoomAnimationTrigger(html.innerHTML);
      },10);


      if (typeof showDynamicPrices === 'function') showDynamicPrices();

      // Handle sticky filter button 
      this.handleStickyFilterButton();

      // Open search popup
      this.triggerSearchPopup();

      // Re-evaluate orphan promos after the grid changes
      setTimeout(() => this.pruneOrphanPromos(), 50);
    }
  }

  // Infinite scroll initialization
  initInfiniteScroll() {
    // at most one check per frame; the check reads layout
    let scheduled = false;
    document.addEventListener("scroll", () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        this.infiniteScrollRender();
      });
    }, { passive: true });
  }

  // Setup initial filters and UTM products
  setupInitialFilters() {
    // hide the special DO / vanilla sections when filters are active
    const gridWrapper = document.querySelector('.product-grid-wrapper');
    if (gridWrapper) {
      if (document.querySelectorAll('.CAT-header__filters input:checked:not([name="sort_by"])').length > 0) {
        gridWrapper.classList.add('hide-DO-special-section');
      } else {
        gridWrapper.classList.remove('hide-DO-special-section');
      }
    }
    setTimeout(() => {
      this.utmProductsFilter();
    }, 200);
  }

  // Setup review-related handlers
  setupReviewHandlers() {
    setTimeout(() => {
      hideLowReviewWidgets();
    }, 1000);
  }

  // Fetch new category items
  async fetchNewCatItems(sectionId, page_nr, target_element, forUTMproduct = false) {
    let query_params = window.location.search.replace("?", "");
    let page_query = `page=${page_nr}`;
    let url = `${window.location.pathname}?section_id=${sectionId}&${query_params}&${page_query}`;

    this.isFetching = true;
    let response = await fetch(url);
    let results = await response.text();
    this.isFetching = false;

    if (forUTMproduct) {
      this.renderNewCATitemsForUTM(target_element, results);
    } else {
      this.renderNewCatItems(target_element, results);
    }

    if (typeof yotpoWidgetsContainer !== 'undefined' && typeof yotpoWidgetsContainer.initWidgets === 'function') {
      yotpoWidgetsContainer.initWidgets();
    }
  }

  // Render new items for UTM products
  renderNewCATitemsForUTM(target, html) {
    const newHTML = new DOMParser().parseFromString(html, 'text/html');
    
    if (newHTML.querySelector('.no-results')) return;

    const currentUrl = window.location.search;
    const urlSearchParams = new URLSearchParams(currentUrl);

    if (!urlSearchParams.has('utm_products')) return;

    const utmProductsValue = urlSearchParams.get('utm_products');

    if (!utmProductsValue) return;

    let arrProducts = utmProductsValue.split("_").filter(Boolean);

    const targetElement = document.querySelector(target);
    if (!targetElement) return;

    arrProducts.forEach(el => {
      const productElement = newHTML.querySelector(`#${el}`);

      if (productElement) {
        const productGridItem = productElement.closest('.grid__item');
        if (productGridItem) {
          targetElement.appendChild(productGridItem);
        }
      }
    });
  }

  // Render new category items
  renderNewCatItems(target, html) {
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');

    if (parsedHtml.querySelector('.no-results')) return;

    parsedHtml.querySelectorAll(".promo-card").forEach(el => el.remove());

    // Append the new cards only. `innerHTML +=` re-parsed and rebuilt every card already
    // in the grid (slow on mobile, and it dropped their listeners/state).
    const newItems = parsedHtml.querySelector(target);
    if (!newItems) return;
    document.querySelector(target).append(...newItems.childNodes);

    setTimeout(() => {
      if (typeof initializeScrollAnimationTrigger === 'function') {
        initializeScrollAnimationTrigger(html.innerHTML);
      }
      if (typeof initializeScrollZoomAnimationTrigger === 'function') {
        initializeScrollZoomAnimationTrigger(html.innerHTML);
      }
    }, 10);


    if (typeof showDynamicPrices === 'function') showDynamicPrices();

    if (this.UTMproductsRearenged) {
      this.removeDuplicateProducts();
    }

    // After new products are appended (infinite scroll), re-evaluate orphan promos.
    // Run multiple times + after the new images load: heights/positions (and the
    // position of full-width trailing promos) only settle once the new rows render
    // and their images load. A single early run leaves trailing promos visible.
    const reRunPrune = () => this.pruneOrphanPromos();
    reRunPrune();
    setTimeout(reRunPrune, 50);
    setTimeout(reRunPrune, 600);
    setTimeout(reRunPrune, 1500);
    const newGrid = document.querySelector('#product-grid');
    if (newGrid) {
      newGrid.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', () => this.schedulePrune(), { once: true });
      });
    }
  }

  // Extract duplicate removal logic into separate method
  removeDuplicateProducts() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const utmProductsValue = urlSearchParams.get('utm_products');
    let arrProducts = utmProductsValue.split("_");
    
    arrProducts.forEach(el => {
      let arrayDublicatedProducts = document.querySelectorAll(`#product-grid #${el}`);
      if (arrayDublicatedProducts.length > 1) {
        for (let i = 1; i <= arrayDublicatedProducts.length - 1; i++) {
          arrayDublicatedProducts[i].closest('.grid__item').remove();
        }
      }
    });
  }

  // Handle infinite scroll rendering
  async infiniteScrollRender() {
    let productGrid = document.querySelector('#product-grid');
    let currentPagesNr = productGrid.dataset.pages;
    
    if (productGrid.classList.contains('pageOne')) {
      this.pageNr = 1;
      productGrid.classList.remove('pageOne');
    }
    
    let viewportHeight = window.innerHeight;
    let scrollY = window.scrollY;

    let productItems = productGrid.querySelectorAll('.grid__item');
    let lastItem = productItems[productItems.length - 1];

    if (!lastItem) return;

    const rect = lastItem.getBoundingClientRect();
    const lastItemPositionInViewport = rect.top + scrollY;

    // Fetch the next page ~1.5 screens before the last card comes into view. Waiting until it
    // was on screen meant the footer was usually visible when the new cards landed and got
    // pushed down (a layout shift of ~0.15).
    const prefetchDistance = viewportHeight * 1.5;

    if (scrollY + viewportHeight + prefetchDistance >= lastItemPositionInViewport) {
      if (this.pageNr < currentPagesNr && this.isFetching == false) {
        this.pageNr++;
        await this.fetchNewCatItems(this.CAT_collection_grid_template_id, this.pageNr, '#product-grid');
      }
    }

    this.offScreenAnimationFix();
  }

  // UTM products filtering
  async utmProductsFilter() {
    const currentUrl = window.location.search;
    const urlSearchParams = new URLSearchParams(currentUrl);

    if (!urlSearchParams.has('utm_products')) {
      return;
    }
    
    const utmProductsValue = urlSearchParams.get('utm_products');
    
    if (document.querySelector('#product-grid').dataset.pages > 1) {
      for (let i = 2; i <= document.querySelector('#product-grid').dataset.pages; i++) {
        await this.fetchNewCatItems(this.CAT_collection_grid_template_id, this.pageNr + 1, '#product-grid', true);
        this.pageNr++;
      }
    }
    
    let arrProducts = utmProductsValue.split("_");
    let ul = document.querySelector("#product-grid");
    let itemsToMove = [];

    arrProducts.forEach(el => {
      for (let i = 0; i < ul.children.length; i++) {
        if (ul.children[i].children[0]?.id == el) {
          itemsToMove.push(ul.children[i]);
          break;
        }
      }
    });

    let itemsToMoveR = itemsToMove.reverse(); // reverse array to show correct order
    itemsToMoveR.forEach(item => {
      ul.removeChild(item); // Remove from current position
      ul.insertBefore(item, ul.firstElementChild); // Insert at the beginning
    });

    this.pageNr = 1;
    this.UTMproductsRearenged = true;
  }

  // Fix off-screen animations
  offScreenAnimationFix() {
    let container = document.querySelector("#product-grid.grid--custom");
    if (!container) return;

    const isElementInViewport = (element) => {
      if (!element) return;
      const rect = element.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    };

    container.querySelectorAll('.scroll-trigger--offscreen').forEach(el => {
      if (isElementInViewport(el)) {
        el.classList.remove('scroll-trigger--offscreen');
      }
    });

    this.handleYotpoReviews();
  }

  // Extract Yotpo review handling into separate method
  handleYotpoReviews() {
    document.querySelectorAll('#product-grid .card--standard').forEach(el => {
      let yotpoText = el.querySelector('.yotpo-sr-bottom-line-text');
      if (yotpoText) {
        let reviewText = yotpoText.innerHTML;
        let reviewNumber = parseFloat(reviewText.match(/\d+(\.\d+)?/));

        if (!isNaN(reviewNumber)) {
          if (reviewNumber < 5) {
            let yotpoWidget = yotpoText.closest('.yotpo-widget-instance');
            if (yotpoWidget) {
              yotpoWidget.style.display = 'none';
            }
          }
        }
      }
    });
  }

  handleStickyFilterButton() {
    const button = document.querySelector(".CAT-header__filters-action");
    if (!button) return;

    const parent = button.parentElement;
    const headerHeight = 111; // px
    const buttonOffsetTop = button.getBoundingClientRect().top + window.scrollY;

    // Function to store the current width in a data attribute
    const updateParentWidth = () => {
      parent.style.setProperty("--sticky-width", `${button.offsetWidth}px`);
    };

    // Set initial width
    updateParentWidth();

    // Observe width changes with ResizeObserver
    const resizeObserver = new ResizeObserver(updateParentWidth);
    resizeObserver.observe(button);

    // Optional: also update width on button click if toggle changes size
    button.addEventListener("click", () => {
      setTimeout(updateParentWidth, 50); // slight delay to allow DOM changes
    });

    // Scroll handling for sticky class
    window.addEventListener("scroll", () => {
      if (window.innerWidth > 990) {
        if (window.scrollY > buttonOffsetTop - headerHeight) {
          parent.classList.add("filters-sticky");
        } else {
          parent.classList.remove("filters-sticky");
        }
      }
    });
  }
}

// Single DOMContentLoaded event listener
document.addEventListener("DOMContentLoaded", () => {
  const collectionGridManager = new CollectionGridManager();
});